module.exports = __webpack_public_path__ + "images/emoji/triumph.4e28b2ab714398a80175.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/triumph.png
// module id = dVJH
// module chunks = 13